
































import Vue from 'vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import { XPorterLeaverServiceSettingsModel } from '@/types/models/XPorter/XPorterLeaverServiceSettingsModel';

export default Vue.extend({
  name: 'XPorterLeaverServiceSettings',
  props: {
    settings: {
      type: Object
    },
    isEditMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    currentPupilsCabinetId: {
      get(this: any) {
        return (this.settings as XPorterLeaverServiceSettingsModel).currentPupilsCabinetId;
      },
      set(this: any, value: string) {
        this.$emit('update', { key: 'currentPupilsCabinetId', value });
      }
    },
    leaverPupilsCabinetId: {
      get(this: any) {
        return (this.settings as XPorterLeaverServiceSettingsModel).leaverPupilsCabinetId;
      },
      set(this: any, value: string) {
        this.$emit('update', { key: 'leaverPupilsCabinetId', value });
      }
    },
    upnReferenceFieldName: {
      get(this: any) {
        return (this.settings as XPorterLeaverServiceSettingsModel).upnReferenceFieldName;
      },
      set(this: any, value: string) {
        this.$emit('update', { key: 'upnReferenceFieldName', value });
      }
    },
    schoolNameReferenceFieldName: {
      get(this: any) {
        return (this.settings as XPorterLeaverServiceSettingsModel).schoolNameReferenceFieldName;
      },
      set(this: any, value: string) {
        this.$emit('update', { key: 'schoolNameReferenceFieldName', value });
      }
    }
  },
  components: { MStoreFormInput }
});
